<template>
    <div v-if="canShow">

        <v-tour name="sideBarTour" :steps="steps.filter(item => item !== null)" :options="myOptions" :callbacks="myCallbacks">
            <template slot-scope="tour" >
                <transition name="fade">
                    <v-step
                        class="bg-primary"
                        style="background: linear-gradient(180deg, rgba(0,0,0,0.3799720571822479) 0%, rgba(0,123,255,0) 50%);"
                        v-if="tour.steps[tour.currentStep]"
                        :key="tour.currentStep"
                        :step="tour.steps[tour.currentStep]"
                        :previous-step="tour.previousStep"
                        :next-step="tour.nextStep"
                        :stop="tour.stop"
                        :skip="tour.skip"
                        :start="tour.start"
                        :finish="tour.finish"
                        :is-first="tour.isFirst"
                        :is-last="tour.isLast"
                        :labels="tour.labels"
                        :highlight="tour.highlight"
                    >
                        <div slot="header" class="fw-bolder text-start mb-2">
                            {{ tour.steps[tour.currentStep].header.title }}
                        </div>
                        <div slot="content" class="text-start mb-2" v-html="tour.steps[tour.currentStep].content">
                        </div>
                        <div slot="actions" v-if="tour.isFirst" class="d-flex justify-content-between align-items-center">
                            <div>{{ tour.currentStep +1 }}/{{tour.steps.length}}</div>
                            <button @click="tour.nextStep" class="btn btn-sm btn-secondary rounded-pill">{{ tour.labels.buttonNext }}</button>
                        </div>
                        <div slot="actions" v-if="!tour.isLast && !tour.isFirst" class="d-flex justify-content-between align-items-center">
                            <div>{{ tour.currentStep +1 }}/{{tour.steps.length}}</div>
                            <div>
                                <button @click="tour.previousStep" class="btn btn-sm btn-link text-secondary rounded-pill">{{ tour.labels.buttonPrevious }}</button>
                                <button @click="tour.nextStep" class="btn btn-sm btn-secondary rounded-pill">{{ tour.labels.buttonNext }}</button>
                            </div>
                        </div>
                        <div slot="actions" v-if="tour.isLast" class="d-flex justify-content-between align-items-center">
                            <div>{{ tour.currentStep +1 }}/{{tour.steps.length}}</div>
                            <div>
                                <button @click="tour.previousStep" class="btn btn-sm btn-link text-secondary rounded-pill">{{ tour.labels.buttonPrevious }}</button>
                                <button @click="tour.stop" class="btn btn-sm btn-secondary rounded-pill">{{ tour.labels.buttonStop }}</button>
                            </div>
                        </div>
                        
                    </v-step>
                </transition>
              </template>
        </v-tour>
    </div>
</template>

<script>
export default {
    props: {
        isAdmin: {
            type: Boolean,
            default: false,
        },
        canShow: {
            type: Boolean,
            default: true,
        },
        permissions: {
            type: Object | null,
            default: null
        }

    },
    data(){
        return {
            myOptions: {
                useKeyboardNavigation: false,
                labels: {
                    buttonSkip: 'Pular',
                    buttonPrevious: 'Anterior',
                    buttonNext: 'Próximo',
                    buttonStop: 'Finalizar'
                },
                highlight: true
            },
            myCallbacks: {
                onStop: this.stopOnboarding,
            },
            steps: [
                {
                    target: '#dashboardTeacher',
                    header: {
                        title: 'Inicio'
                    },
                    content: 'Bem-vindo à plataforma E-correção! Aqui, você encontrará dados gerais da sua organização e outras informações relevantes. Clique<a class="btn btn-link text-secondary" target="_blanck" href="https://www.youtube.com/watch?v=h-CcpBAEQkA&ab_channel=E-corre%C3%A7%C3%A3o">aqui</a> aqui para saber mais.',
                    params: {
                        placement: 'right-end',
                        
                    }
                },
                this.isAdmin | (this.permissions && this.permissions.permission_groups) ?
                {
                    target: '#groupsTeacher',
                    header: {
                        title: 'Turmas'
                    },
                    content: 'Neste menu, você pode gerenciar suas turmas e alocar seus alunos. Clique<a class="btn btn-link text-secondary" target="_blanck" href="https://www.youtube.com/watch?v=nGfLKLydmqM&embeds_referring_euri=http%3A%2F%2Flocalhost%2F&source_ve_path=MjM4NTE">aqui</a> aqui para saber mais.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,
                this.isAdmin | (this.permissions && this.permissions.permission_students) ?
                {
                    target: '#studentsTeacher',
                    header: {
                        title: 'Alunos'
                    },
                    content: 'Após criar ao menos uma turma, neste menu você poderá cadastrar e gerenciar seus alunos para que tenham acesso à plataforma.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,
                this.isAdmin ?
                {
                    target: '#teachersMenu',
                    header: {
                        title: 'Professores'
                    },
                    content: 'Aqui, você poderá gerenciar os professores da plataforma e alterar individualmente as permissões de acesso aos recursos.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,
                this.isAdmin | (this.permissions && this.permissions.permission_themes) ?
                {
                    target: '#themesMenu',
                    header: {
                        title: 'Temas'
                    },
                    content: 'Neste menu, você poderá criar temas para serem usados no envio das redações de suas turmas.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,
                this.isAdmin | (this.permissions && this.permissions.permission_essays) ?
                {
                    target: '#essaysMenu',
                    header: {
                        title: 'Redações'
                    },
                    content: 'Aqui, você realizará todo o gerenciamento das redações enviadas e corrigidas, além de acessar e realizar as correções.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,
                this.isAdmin ?
                {
                    target: '#integrationMenu',
                    header: {
                        title: 'Integrações'
                    },
                    content: 'Aqui, você pode realizar integrações com plataformas de venda, como Hotmart, além de configurar um domínio personalizado e outras opções.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,
                this.isAdmin ?
                {
                    target: '#configurationMenu',
                    header: {
                        title: 'Configuração'
                    },
                    content: 'Aqui, você configura todo o seu ambiente, desde funções adicionais e específicas até a personalização da plataforma.',
                    params: {
                        placement: 'right-end'
                    }
                }: null,

            ]
        }
    },
    methods: {
        stopOnboarding(){
            axios.put('/teacher/teachers/finish-onboarding').then((result) => {
                
            }).catch((err) => {
                
            });
        }
    },
    created(){

        console.log(this.permissions)
    },
    mounted() {
        this.$tours['sideBarTour'].start()
    }
}
</script>

<style>
.v-tour__target--highlighted {
    box-shadow: 0 0 0 9999px rgba(0,0,0,.5);
}
.v-step > .v-step__arrow{
    color: white;
    background-color: inherit;
}

</style>
